module.exports = __webpack_public_path__ + "img/ruanjainbig.a3a71104.gif";